import { IProduct } from 'core/redux/features/products/types';
import React from 'react';
import { voidCallback } from 'core/utils';
import classNames from 'classnames';

interface IProps {
  product?: IProduct;
  filterResult?: string[];
  active: boolean;
  $onMouseAllow?: (arg: boolean) => void;
  onClickBoard: (e: React.SyntheticEvent, p: IProduct) => void;
  type?: string;
  lat?: string;
  lng?: string;
}

export function MapMarker(props: IProps) {
  const { filterResult, type, active } = props;
  return (
    <div>
      <div
        className={classNames(
          'map-marker',
          active && 'is-active',
          `map--${type}`,
          filterResult.length > 0 && 'map-marker--filtered',
        )}
      >
        <div className="map-marker-in" />
      </div>
    </div>
  );
}

MapMarker.defaultProps = {
  onClickBoard: voidCallback,
  type: 'product',
  filterResult: [],
};
